import styled, { keyframes } from 'styled-components';

export const ProgressContent = styled.div`
  flex: 1;
  width: 100%;
  height: 1.5rem;
  left: 0px;
  top: 0px;
  position: fixed;
  z-index: 4000;
  background: ${({ theme }) => theme.colors.PROGRESS_BG};
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 1px 5px 5px rgba(0, 0, 0, 0.05);
`;

const ProgressIcAnimation = keyframes`  
  0% { width: 0px; }
  100% { width: 92%; }
`;

export const ProgressIc = styled.div`
  float: left;
  width: 92%;
  height: 100%;
  background: ${({ theme }) => theme.colors.PROGRESS_OVERLAY_BG};
  animation-name: ${ProgressIcAnimation};
  animation-duration: 10s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-play-state: running;
`;
